import {
  Component,
  OnInit,
  OnDestroy,
  HostListener,
  Input,
  EventEmitter,
  Output,
  SimpleChanges,
  ChangeDetectorRef,
  AfterViewInit,
} from "@angular/core";
import { AgGridTableService } from "../../services/ag-grid.service";
import { Subscription, takeUntil } from "rxjs";
import { CommonModule } from "@angular/common";
import { AgGridAngular } from "ag-grid-angular";
import { GridApi } from "ag-grid-community";
import { ApiCallsService } from "../../services/api-calls.service";
import { ActivatedRoute, RouterModule } from "@angular/router";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { FlatpickrDirective,provideFlatpickrDefaults,
} from "angularx-flatpickr";
import { getFlatpickrDefaults } from "../flatpickr-defaults";
import { SiteSearchService } from "../../services/site-search.service";
import { NgSelectModule } from "@ng-select/ng-select";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
export interface DropdownItem {
  site_id: string;
  site_name: string;
  selected: boolean;
}
interface Site {
  site_id: string;
  site_name: string;
}
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect';
import { FormsModule } from "@angular/forms";
import { DestroyableComponent } from "../../services/destroyable.component";
import { ToastService } from "../../services/toast.service";
import { ModalsPaginationService } from "./Modal-pagination.service";


@Component({
  selector: "app-Modaltable",
  templateUrl: "./Modaltable.component.html",
  imports: [
    CommonModule,
    NgbModule,
    AgGridAngular,
    FormsModule,
    NgbTooltipModule,
    FlatpickrDirective,
    NgSelectModule,
    RouterModule,
    NgbModule
  ],
  standalone: true,
  styleUrl: "./Modaltable.component.scss",
  providers: [provideFlatpickrDefaults(getFlatpickrDefaults())],
})


export class ModalTableComponent extends DestroyableComponent implements OnInit, OnDestroy {
  Modaltitle:string=''
  dateRange: string | Date[] = [// Setting date Range
    new Date(new Date().setDate(new Date().getDate() - 1)),
    new Date(),
  ];
  tableshowsubscription :Subscription 
  tabledatasubscription :Subscription 
  columnApi :any
  @Input() location : boolean = false
    searchTerm = '';
    selectedValue: string = '';
    internalOptions: Site[] = [];
    selectedCommand: string = '';
    CustomOutlineData = [
        {
            item: [
                {
                    class: 'btn-outline-primary',
                    text: 'Site',
                    key:'site_wise'
                },
                {
                    class: 'btn-outline-primary',
                    text: 'Gateway',
                    key:'datalogger'
                }
            ]
        },
      ]
    autoSizeStrategy: {
        type: 'fitCellContents'
      }
  editId:string = ''
  @Input() ResetPage : boolean = false
  @Output() DataTypeDatalogger = new EventEmitter<string>()
  isLoading = false; // Property to track loading state
  isFloatingFilterEnabled = true;
  filterIcon = "assets/images/Icons/filter-active.png";
  receivedData = "";
  showColumnMenu = false;
  isHideAllDisabled = false;
  isShowAllDisabled = false;
  public gridApi!: GridApi;// Define AG-grid to call its inbuilt functions
  isSearchOpen = false;  
  formattedFromDate: string = "";// From date
  formattedToDate: string = "";// To date
  isOpen:boolean = false
  @Input() modalId:string=''
  grandTotalRow: "top" | "bottom" | "pinnedTop" | "pinnedBottom" = "bottom";
  pinnedBottomRowData: any[] = []; 
  pinnedBottomRowDataModal: any[] = []; 
  @Input() TableHeader:string = ''
  @Input() ShowDLFilter:boolean = false
  screenWidth: number = window.innerWidth;
  isMobileView: boolean = this.screenWidth <= 600;
  @Input() statusMap: Record<string, 'active' | 'inactive'> = {};
  @Input() filterConfig: { key: string; label: string }[] = [];
  @Input() mode: 'date' | 'month' = 'date'; // input from parent
  plugins: any[] = [];
  altFormat = 'd/m/Y';
  dateFormat = 'Y-m-d';
  placeholder = 'From - To';
  rangeMode: 'range' | 'single'  = 'range';
  @Output() statusUpdated = new EventEmitter<{ key: string; value: 'inactive' }>();
  @Output() records = new EventEmitter<any>();
  selectedKey: string = 'site_wise';
  @Input() ResetPagination : boolean = false
  @Input() addApplication: boolean = false;
  @Input() AddBulkaction: boolean = false;
  tableHeadersubscription: Subscription;
  updateStatus(key: string): void {
    const payload: { key: string; value: 'inactive' } = { key, value: 'inactive' };
    this.statusUpdated.emit(payload);
  }
  updateViewMode(): void {// to show filters for mobile view
    this.screenWidth = window.innerWidth;
    this.isMobileView = this.screenWidth <= 600;
  }
 get activeFiltersCount(): number {
    return this.filterConfig.filter(filter => this.statusMap[filter.key] === 'active').length;
  }
  toggleDropdown(): void {
    this.isOpen = !this.isOpen;
  }
  SelectDataloggerData(key: string) {
    this.selectedKey = key;  // set the selected key
    this.DataTypeDatalogger.emit(key);
  }
  Additem(payload:any){
    console.log(payload);
    this.records.emit(payload)
  }

  columnDefs: any[] = [];
  rowData: any[] = [];
  defaultColDef = {// These are default values set for configs of ag-grid.
    resizable: true,//Can resize column
    sortable: true,
    filter: false,//Enable quick filter
    suppressMovable: true,//Dissable moving of rows left or right
    floatingFilter: true,
    flex: 1,// To set the table width fit and not leave empty space 
  };
  isQuickFilterActive: boolean = false;//Check if there is text inside the quick filter

  @Input() paginationPageSizeSelector: number[] | boolean = [10, 20, 50, 100];// By default pageination is this, but can be changed if given from Parent component
  rowdatasubscriptionModal: Subscription | null;
  rowModalsubs:Subscription | null;

  @Output() filtersApplied = new EventEmitter<{  // from and to date Output to parent component
    from_date: string;
    to_date: string;
  }>();
  @Input() Date : {  // from and to date Output to parent component
    from_date: string;
    to_date: string;
  }
  @Input() displayAddbutton : boolean = false
  @Input() pageNation: boolean = true;
  @Input() pageNationModal: boolean = false;
  @Input() DateFilterShow: boolean = false;
  @Input() Reload:boolean = false
  @Input() totalDisplay:boolean = false
  @Input() buttonTitle:string;
  @Output() pageNumber = new EventEmitter<number>();
  @Output() clearSupervisorHighlight = new EventEmitter<void>();
  maxRowCount: number = 0;

  hasTriggeredLastPage = false;
  siteid:string|null=''
  shortcode:string = ''

  public currentPage = 1;
  public totalRows = 0;

  private pageSize: number = 10; // Default, can be changed by onPageSizeChanged
    gridOptions = {
      overlayNoRowsTemplate:
        '<span class="no-data-line">No Data found</span>'
    };

  private previousMaxRowCount: number = -1;

  constructor(
    private tableService: AgGridTableService,
    private route: ActivatedRoute,
    private toast:ToastService,
    private modalpagination:ModalsPaginationService
  ) {
    super()
  }
  modaltitle2:string =''
ngOnInit() {
  /* -------------------- EXISTING INIT LOGIC (UNCHANGED) -------------------- */

  
  
  this.updateViewMode(); // initialize once

  if (this.DateFilterShow) {
    if (this.mode === 'month') {
      this.setupMonthPicker();
    } else {
      this.setupDatePicker();
    }
  }

  this.updateViewMode(); // initialize once
  window.addEventListener('resize', this.updateViewMode.bind(this));



  this.modalpagination.totalCount$.subscribe(res=>{
    this.maxRowCount = res
  })
  this.tableHeadersubscription = this.tableService.ModaltableTitleSubject$.subscribe(res => {
    this.Modaltitle = res;
  });
  this.tabledatasubscription = this.tableService.ModaltableDataPayload$.subscribe(res => {
    console.log('Modal Payload:', res, 'Title:', this.Modaltitle);
    this.modalpagination.initFilters(res.payload, res.apiurl, this.destroy$, this.Modaltitle);
  });
  this.tableshowsubscription = this.tableService.ModalDisplay$.subscribe(() => {
    if (this.Modaltitle) {
      const lastIdx = this.Modaltitle.lastIndexOf('_');
      if (lastIdx !== -1) {
        this.modaltitle2 = this.Modaltitle.substring(lastIdx + 1);
        this.Modaltitle = this.Modaltitle.substring(0, lastIdx);
      } else {
        this.modaltitle2 = this.Modaltitle;
        this.Modaltitle = '';
      }
      if (this.modaltitle2) {
        this.modaltitle2 = this.modaltitle2.replace(/\bcb\b/i, 'CB');
      }
    }
    if (!this.bootstrapModal) {
      this.modal = document.getElementById('ModalTable');
      if (this.modal && (window as any).bootstrap?.Modal) {
        this.bootstrapModal = new (window as any).bootstrap.Modal(this.modal, {
          backdrop: 'static',
          keyboard: false,
        });
      }
    }
    this.bootstrapModal?.show();
  });
 
  this.rowdatasubscriptionModal = this.tableService.ModaltableData$.subscribe(
    ({ columnDefs, rowData, pinnedBottomRowData }) => {
      this.columnDefs = columnDefs;
      if (this.pageNation) {        
        this.columnDefs = this.columnDefs.map(col => ({
        ...col,
        sortable: false,
        floatingFilter: false
      }));
      }
      this.rowData = rowData;
      this.totalRows = this.maxRowCount;
      this.pinnedBottomRowData = pinnedBottomRowData || [];
      if (this.gridApi) {
        
        this.gridApi.setGridOption('rowData', this.rowData);

        if (this.totalDisplay) {
          this.gridApi.setGridOption('pinnedBottomRowData', this.pinnedBottomRowData);
          
        } else {
          this.gridApi.setGridOption('pinnedBottomRowData', []);
        }

        // ✅ notify service that table is now ready
        if (this.columnDefs.length !==0) {
        this.handleTypeQueryParam()
        }
      }
    }
  );
  /* -------------------- Pagination Reset Subscription ---------------------*/
  // this.reportPaginationService.payloadChanged$
  // .pipe(takeUntil(this.destroy$))
  // .subscribe(changed => {
  //   if (changed) {
  //       this.ResetPagination = true
  //   }
  // });
  // this.LogPaginationService.payloadChanged$
  // .pipe(takeUntil(this.destroy$))
  // .subscribe(changed => {
  //   if (changed) {
  //       this.ResetPagination = true
  //   }
  // });

}



  onClearSupervisor() {
    this.clearSupervisorHighlight.emit();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["data"] || changes["resetTrigger"]) {
      this.hasTriggeredLastPage = true;
    }
    if (changes['Date'] && this.Date?.from_date && this.Date?.to_date) {
      this.dateRange = [
        new Date(this.Date.from_date),
        new Date(this.Date.to_date)
      ];
    }
    
        if (changes['filterConfig'] && this.filterConfig?.length) {
      console.log('✅ filterConfig received in child:', this.filterConfig);
      // You can now safely use this.filterConfig
    }
  }


//The below whole code is for Pagination in Reports and other pages with API that takes page number and size as an input
//It works like this -> Max Count taken as input from the component, this max number is used to create an array of Max pagenumbers 
//The parent component(Take any Reports as example) where its called, Sends the Data using processdata function of ag grid service
//The data that sends is a array of duplicated data (Similar to Infinite Function of enterprise Ag grid but this works the same)
//This helps to show the total numeber of existing data, total page numbers
//Whenever next page event is run, the array updates that page, and Replaces the duplicate data with the API data
closemodal(){
  console.log('close');
  
  this.ResetPagination = true
  this.tableService.processTableDataModal([])
  this.rowData = []
  this.columnDefs = []
  this.modalpagination.reset()
  this.bootstrapModal.hide()
}
  private loadedPages: { [pageSize: number]: number[] } = {};
  private visitedPages: { [pageSize: number]: number[] } = {}; // For your updateVisitedPages logic
  private isInternalNavigationUpdate: boolean = false; // Prevents re-entrant calls in onPaginationChanged 

public onPaginationChanged(event?: any): void {
  if (this.ResetPagination) {
    this.previousMaxRowCount = this.maxRowCount;
    this.isInternalNavigationUpdate = true;
    this.gridApi?.paginationGoToFirstPage();
    this.resetPaginationMemory();
    this.ResetPagination = false
    return;
  
  }

  if (this.isInternalNavigationUpdate) {
    this.isInternalNavigationUpdate = false;
    return;
  }

  if (
    !this.pageNation ||
    !this.gridApi ||
    !this.pageSize ||
    this.maxRowCount < 0
  ) {
    return;
  }

  const agGridReportedPage_0idx = this.gridApi.paginationGetCurrentPage();//Get current page number
  const agGridReportedPage_1idx = agGridReportedPage_0idx + 1;// Add 1 to the current page
  const agGridPageSize = this.gridApi.paginationGetPageSize();

  // --- The rest of your logic is mostly correct for page NAVIGATION ---
  const actualTotalServerPages = this.calculateActualTotalPages();// Get total number of pages from server side , Uses max count to calculate
  let targetPageForData = agGridReportedPage_1idx;// The next page after the current one

  if (actualTotalServerPages > 0 && targetPageForData > actualTotalServerPages) {// Just a fail safe if there is only 1 page
    targetPageForData = actualTotalServerPages;
  } else if (targetPageForData < 1) {
    targetPageForData = 1;
  }

  const previousComponentPage = this.currentPage;
  this.currentPage = targetPageForData;
  

if (!this.loadedPages[agGridPageSize]) {
  this.loadedPages[agGridPageSize] = [];
}

const currentLoadedPages = this.loadedPages[agGridPageSize];
if (actualTotalServerPages === 0) {
  return; // No pages to show, don't emit
}

const isInitialZeroToOne =
  this.previousMaxRowCount === 0 &&
  this.maxRowCount > 0 &&
  this.currentPage === 1;

// ✅ pageSize change must always emit page 1
const isPageSizeChange = event?.newPageSize === true;

// ✅ real user navigation (2→1, last→first, etc.)
const isUserPageNavigation = event?.newPage === true;

// ❌ skip only the initial data-load pagination
if (isInitialZeroToOne) {
  // do nothing
}
else if (
  (isPageSizeChange || isUserPageNavigation) &&
  !currentLoadedPages.includes(this.currentPage)
) {
  console.log({
    page: this.currentPage,
    pageSize: agGridPageSize
  });
  
  this.modalpagination.changePage({
    page: this.currentPage,
    pageSize: agGridPageSize
  }, this.destroy$);


  currentLoadedPages.push(this.currentPage);
  currentLoadedPages.sort((a, b) => a - b);
}


  if (this.gridApi.paginationGetCurrentPage() !== this.currentPage - 1) {// 
    this.isInternalNavigationUpdate = true;
    this.gridApi.paginationGoToPage(this.currentPage - 1);
  }
  this.previousMaxRowCount = this.maxRowCount;

  this.updateVisitedPages();
}


  private calculateActualTotalPages(): number {// Returns total number of pages to exist
    if (this.maxRowCount === 0) {
        return 0; // Explicitly handle the case of zero rows
    }
    if (!this.maxRowCount || !this.pageSize) {
      return 1; // Default to 1 page if data is missing, unless row count is 0
    }
    return Math.ceil(this.maxRowCount / this.pageSize);
  }


  // --- Original Helper Functions (with minor adjustments) ---
  private updateVisitedPages(): void {
    if (!this.pageSize) return; // Guard against undefined pageSize
    if (!this.visitedPages[this.pageSize]) { 
      this.visitedPages[this.pageSize] = [];
    }
    if (!this.visitedPages[this.pageSize].includes(this.currentPage)) {
      this.visitedPages[this.pageSize].push(this.currentPage);//This is to help maintain an array that stores the pages api was called in, So as to not have duplicate Data
    }
  }
  private resetPaginationMemory(): void {
  this.loadedPages = {};
  this.visitedPages = {};
  this.currentPage = 1;
}

//pagination related code ends

  onGridReady(params: any) { // This set of code runs after the table is initiated
    this.gridApi = params.api;  
    this.columnApi = params.columnApi;

              if (this.pageNation) {// In report pages, dont want to show the floating filter, hence set the value as false here
            this.defaultColDef = {
              ...this.defaultColDef,
              floatingFilter: false,// For tables wherever pagination is implmented, the floating filters have been removed
            };       
          }
  }



  onCellFiltter(value?: string, field?: string): void {
    if (!field || !this.gridApi) return;

    this.gridApi.getColumnFilterInstance(field).then(filterInstance => {
      if (!filterInstance) return;

      filterInstance.setModel({
        type: 'contains',
        filter: value ?? ''
      });

      this.gridApi.onFilterChanged();
    });
  }


 @Input() ExportFileName:string = ''  
//  @Input() exportFileName: string = 'ExportedData';
  onExport() {
    if (this.rowData.length === 0) {
      this.toast.showToast('Table data is empty','colored',5000,'warning')
      return
    }
    else {      
      this.modalpagination.downloadCSV(this.destroy$,this.columnDefs,`${this.modaltitle2}-${this.Modaltitle}`);
    }

  }
  
  //This is the flatpicker date setting code, It originally does not send a string, so conversion to string is necessary, And the taking out the from date and to date differently

    monthPlugins = [
    monthSelectPlugin({
      shorthand: true,  // shows "Jan", "Feb"
      dateFormat: 'Y-m', // backend format
      altFormat: 'F Y',  // UI display format
      theme: 'light'     // can be 'dark' too
    })
  ];
setupMonthPicker() {
    this.plugins = [
      monthSelectPlugin({
        shorthand: true,
        dateFormat: 'Y-m',
        altFormat: 'F Y',
        theme: 'light',
      }),
    ];
    this.altFormat = 'F Y';
    this.dateFormat = 'Y-m';
    this.placeholder = 'Select month range';
  }

  setupDatePicker() {
    this.plugins = []; // no plugins for normal date picker
    this.altFormat = 'd/m/Y';
    this.dateFormat = 'Y-m-d';
    this.placeholder = 'From - To';
  }
  updateFormattedDates(): void {
    if (!this.DateFilterShow) return;

    const formatDate = (d: Date) => d.toISOString().split("T")[0];
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    this.formattedFromDate = "";
    this.formattedToDate = "";

    let fromDate: Date | null = null;
    let toDate: Date | null = null;

    if (typeof this.dateRange === "string") {
      const [fromStr, toStr] = this.dateRange.split(" to ");
      fromDate = new Date(fromStr.trim());
      toDate = toStr ? new Date(toStr.trim()) : null;
    } else if (Array.isArray(this.dateRange)) {
      fromDate = this.dateRange[0];
      toDate = this.dateRange[1] ?? null;
    }

    // Normalize date parts to ignore time
    const isSameDay = (d1: Date, d2: Date) =>
      d1.toDateString() === d2.toDateString();

    if (fromDate instanceof Date && !isNaN(fromDate.getTime())) {
      if (toDate instanceof Date && !isNaN(toDate.getTime())) {
        // ✅ Case 1: Both dates selected
        this.formattedFromDate = formatDate(fromDate);
        this.formattedToDate = formatDate(toDate);
      } else {
        if (isSameDay(fromDate, today)) {
          // ✅ Case 2: Only today selected — auto use yesterday as from
          this.formattedFromDate = formatDate(yesterday);
          this.formattedToDate = formatDate(today);
        } else {
          // ❌ Case 3: Only 1 non-today date selected — ignore
          console.warn("Only one non-today date selected — skipping emit.");
          return;
        }
      }
    } else {
      // ❌ Case 4: Invalid date(s)
      console.warn("Invalid date range selected.");
      return;
    }

    const payload = {
      from_date: this.formattedFromDate,
      to_date: this.formattedToDate,
    };

    console.log("Raw dateRange value:", this.dateRange);
    console.log("[applyFilters] Emitting payload to parent:", payload);
    this.filtersApplied.emit(payload);
  }
  

  // This code Below is to fetch data for different Tables for site summary , Each case is Sending different parameters value for different routes

  override ngOnDestroy() {
      window.removeEventListener('resize', this.updateViewMode.bind(this));
      console.log('destroy');

    if (this.gridApi && !this.gridApi.isDestroyed()) {
      this.gridApi.setGridOption('rowData', []);
      this.gridApi.setGridOption('pinnedBottomRowData', []);
      this.gridApi.destroy(); // VERY important
    }

    document.querySelectorAll('.modal-backdrop')
    .forEach(el => el.remove());

  // Reset body state
  document.body.classList.remove('modal-open');
  document.body.style.removeProperty('padding-right');

  // Force-hide modal if still present
  const modal = document.getElementById('ModalTable');
  if (modal) {
    modal.classList.remove('show');
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
  }
  this.bootstrapModal = null
    this.pageNation = false;
    this.columnDefs = [];
    this.rowData = [];
    if (this.tableHeadersubscription) {
      this.tableHeadersubscription.unsubscribe()
    } 
    if (this.tabledatasubscription) {
      this.tabledatasubscription.unsubscribe()
    } 
    if (this.tableshowsubscription) {
      this.tableshowsubscription.unsubscribe()
    } 
  }

  // Below code is for all the toggles , Search , Column search filter, show columns, download csv 
    onFilterTextBoxChanged(): void { // Quick filter code , AG-grid
      
    const filterText = (
      document.getElementById("filter-text-box") as HTMLInputElement
    ).value;
    
    // Apply the quick filter
    this.gridApi.setGridOption("quickFilterText", filterText);

    // Reset pagination offset and stop additional data fetching when filtering is applied
    if (filterText) { // These checks is so that incase while searching, The pagination bit of code does not work, as it can cause issue with pageSize and numbers checks
      this.isQuickFilterActive = true;
    } else {
      this.isQuickFilterActive = false;
    }
  }
    onMainSearchChange(): void { // Quick filter code , AG-grid
      // alert("xa")
      if (this.gridApi) {
        //alert("hello1");
        this.gridApi.setFilterModel(null); // Reset all filters
        this.gridApi.onFilterChanged();    // Notify grid of filter change
        this.gridApi.refreshHeader();      // Refresh header to clear floating filter UI
      }
    const filterText = (
      document.getElementById("filter-text-box") as HTMLInputElement
    ).value;
    
    // Apply the quick filter
    this.gridApi.setGridOption("quickFilterText", filterText);

    // Reset pagination offset and stop additional data fetching when filtering is applied
    if (filterText) { // These checks is so that incase while searching, The pagination bit of code does not work, as it can cause issue with pageSize and numbers checks
      this.isQuickFilterActive = true;
    } else {
      this.isQuickFilterActive = false;
    }
  }


  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent): void {  //Show or hide the column for the column chooser
    const target = event.target as HTMLElement;
    const columnMenuElement = document.querySelector(".column-menu-wrapper");

    if (
      this.showColumnMenu &&
      columnMenuElement &&
      !columnMenuElement.contains(target)
    ) {
      this.showColumnMenu = false; // Hide the column menu
    }
  }

  toggleColumnVisibilityByField(field: string, show: boolean): void { //Show or hide Specific column
    const colDef = this.columnDefs.find((col) => col.field === field);
    // console.log(colDef);
    if (colDef) {
      colDef.hide = !show; // Set visibility based on the `show` parameter
      this.columnDefs = [...this.columnDefs]; // Trigger change detection
      console.log(
        `Column "${field}" visibility set to: ${show ? "visible" : "hidden"}`
      );
    } else {
      console.warn(`Column with field "${field}" not found.`);
    }
  }
  hideAll() {
    //hide all columns
    this.columnDefs.forEach((colDef) => (colDef.hide = true));
    this.columnDefs = [...this.columnDefs];
    this.isHideAllDisabled = true;
    this.isShowAllDisabled = false;
  }

  showAll() {
    //show all columns
    this.columnDefs.forEach((colDef) => (colDef.hide = false));
    this.columnDefs = [...this.columnDefs];
    this.isHideAllDisabled = false;
    this.isShowAllDisabled = true;
  }
  
  toggleFloatingFilter() { // Individual column filters
    this.isFloatingFilterEnabled = !this.isFloatingFilterEnabled;
    this.filterIcon = this.isFloatingFilterEnabled
      ? "assets/images/Icons/filter-active.png"
      : "assets/images/Icons/filter.png";
    this.defaultColDef = {
      ...this.defaultColDef,
      floatingFilter: this.isFloatingFilterEnabled,
    };

    // Force the grid to refresh with new settings
    this.columnDefs = [...this.columnDefs];
  }

  toggleColumnMenu(event: MouseEvent) {
    event.stopPropagation(); // Prevent the click event from propagating to the document
    this.showColumnMenu = !this.showColumnMenu;
  }
  toggleSearch() {
    this.isSearchOpen = !this.isSearchOpen;

    if (this.isSearchOpen) {
      // setTimeout(() => this.searchInput.nativeElement.focus(), 200);
    }
  }
  handleTypeQueryParam(): void {
  const type = this.route.snapshot.queryParamMap.get('type');
  if (!type) return;
    this.toggleColumnVisibilityByField('admin_status',true);
    setTimeout(() => {
      this.onCellFiltter(type,'admin_status')
    }, 100);

}

  toggleColumnVisibility(colDef: any) {// Selected Columns are Shown and hidden
    console.log(colDef);
    colDef.hide = !colDef.hide;
    this.columnDefs = [...this.columnDefs];
    this.isHideAllDisabled = false;
    this.isShowAllDisabled = false;
  }

  
  basicdropdownitem: any[] = [];
  isLoaded: boolean = false;

  // getsitelist() {
  //   // Agar pehle se load ho chuka hai, to dobara call mat karo
  //   if (this.isLoaded) return;

  //   this.apiService.getSiteList().subscribe(data => {
  //     this.basicdropdownitem = [
  //       ...data.Data.list
  //     ];
  //     localStorage.setItem('siteList', JSON.stringify(data.Data.list));
  //     this.isLoaded = true; // Mark as loaded
  //   });
  // }
   CreateBulkAction(){
    window.location.href='CreateBulkAction';
  }


    get filteredItems(): Site[] {
      if (!this.internalOptions.length) return [];
      if (!this.searchTerm.trim()) return this.internalOptions;

      const lower = this.searchTerm.toLowerCase();
      return this.internalOptions.filter(site =>
        site.site_name.toLowerCase().includes(lower)
      );
    }

    selectOption(site: Site) {
      this.searchTerm = site.site_name;   // 👈 input box me selected naam dikhega
      this.selectedValue = site.site_id;  // 👈 selected id rakhega
    }

    onInputChange(event: Event) {
      const input = event.target as HTMLInputElement;
      this.searchTerm = input.value;
      this.selectedValue = '';  // 👈 input edit kare to selected id reset
    }
  modal :any 
  bootstrapModal: any
    ngAfterViewInit() {
    this.modal = document.getElementById('ModalTable');
    if (this.modal) {
      this.bootstrapModal = new (window as any).bootstrap.Modal(this.modal,{
        backdrop: 'static',
        keyboard: false
      });
    }

  }
}

